export const routes = {
  admin: "admin",
  dashboard: "dashboard",
  artefact: "artefact",
  artefactApproval: "artefact-approvals",
  versionApproval: "artefact-approvals-version",
  artefactList: "artefact-list",
  usecase: "use-case",
  model: "models",
  detailsInfo: "details-info",
  sectorList: "sector-list",
  orgDetails: "org-details",
  datasets: "datasets",
  all: "all",
  details: "details",
  support: "support",
  contactUs: "contact-us",
  organisation: "organisation",
  notebook: "notebook",
  article: "article",
  content: "content",
};
